import { useEffect, useState } from "react";
import api, { errorMessage } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Button } from "./ui/button";
import { Copy, Gift, Users } from "lucide-react";
import { toast } from "sonner";

export default function ReferralCard() {
  const { t } = useI18n();
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/referrals/me").then((r) => setData(r.data)); }, []);

  if (!data || !data.code) return null;

  const link = `${window.location.origin}/signup?ref=${data.code}`;

  const copyLink = () => {
    navigator.clipboard.writeText(link);
    toast.success(t("referral_link_copied"));
  };

  return (
    <div className="rounded-md border border-orange-500/20 bg-gradient-to-br from-orange-500/[0.06] to-transparent p-6 mb-10" data-testid="referral-card">
      <div className="flex items-start gap-4 flex-wrap">
        <div className="w-10 h-10 rounded-full bg-orange-500/20 flex items-center justify-center flex-shrink-0">
          <Gift className="w-5 h-5 text-orange-400" />
        </div>
        <div className="flex-1 min-w-[280px]">
          <div className="text-[10px] uppercase tracking-[0.2em] text-orange-400 font-bold mb-1">{t("referrals")}</div>
          <h3 className="font-black text-xl tracking-tight mb-1">{t("referral_your_code")}: <span className="text-orange-400" data-testid="referral-code">{data.code}</span></h3>
          <p className="text-sm text-zinc-400 mb-4">
            {t("referral_share_msg", { n: data.bonus_per_referral || 30 })}
          </p>
          <div className="flex gap-2 flex-wrap items-center">
            <div className="flex-1 min-w-[220px] rounded-full bg-[#121218] border border-white/10 px-4 py-2 text-xs text-zinc-400 font-mono truncate" data-testid="referral-link">
              {link}
            </div>
            <Button onClick={copyLink} data-testid="copy-referral-btn" className="rounded-full bg-orange-500 hover:bg-orange-600 text-black font-bold">
              <Copy className="w-4 h-4 mr-2" /> {t("referral_copy_link")}
            </Button>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4 mt-6 pt-6 border-t border-white/10">
        <Stat label={t("referral_invited")} value={data.referred_count} testid="ref-invited" />
        <Stat label={t("referral_upgraded")} value={data.upgraded_count} testid="ref-upgraded" />
        <Stat label={t("referral_bonus_earned")} value={`+${data.bonus_earned}`} testid="ref-bonus" />
      </div>
    </div>
  );
}

function Stat({ label, value, testid }) {
  return (
    <div data-testid={testid}>
      <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-bold">{label}</div>
      <div className="font-black text-2xl mt-1">{value}</div>
    </div>
  );
}
